import { render, staticRenderFns } from "./Filelist.vue?vue&type=template&id=3865b526&scoped=true"
import script from "./Filelist.vue?vue&type=script&lang=ts"
export * from "./Filelist.vue?vue&type=script&lang=ts"
import style0 from "./Filelist.vue?vue&type=style&index=0&id=3865b526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3865b526",
  null
  
)

export default component.exports